module.exports = __webpack_public_path__ + "static/media/shop-store-ecommerce-svgrepo-com.48b3ee7b.svg";